import styles from "@/styles/Manage.module.scss"
import { ManageListEntryActionProps } from "./interface"

export default function ManageListEntryAction({
  clickHandler,
  iconSrc,
  text,
  textStyle,
}: ManageListEntryActionProps) {
  return (
    <div className={styles.entryActionDropdownItem} onClick={clickHandler}>
      <img
        className={styles.entryActionIcon}
        src={iconSrc}
        width="16px"
        alt=""
      />
      <span style={textStyle}>{text}</span>
    </div>
  )
}
